var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.forHero)?_c('v-runtime-template',{staticClass:"activity-description-md",attrs:{"template":_vm.articleTemplate}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.heroActivitySynopsis)}})}
var staticRenderFns = []

export { render, staticRenderFns }